<!-- 文件预览 -->
<template>
  <span>
    <span v-if="$route.query.p == 'GFTYX20H'">
      <a href="javascript:;" @click="goFileView(5)"
        :class="[readArray.indexOf(5) > -1 ? 'readed_' : 'unread']">《投保须知》</a>
      <a href="javascript:;" @click="goFileView(2)"
        :class="[readArray.indexOf(2) > -1 ? 'readed_' : 'unread']">《国富人寿团体意外伤害保险（互联网专属）条款》</a>
      <a href="javascript:;" @click="goFileView(0)"
        :class="[readArray.indexOf(0) > -1 ? 'readed_' : 'unread']">《投保人声明》</a>
      <a href="javascript:;" @click="goFileView(99, '拒保职业清单')" :class="[readArray.indexOf('99拒保职业清单') > -1 ? 'readed_' : 'unread']">《拒保职业清单》</a>
      <a href="javascript:;" @click="goFileView(99, '免除医院清单')" :class="[readArray.indexOf('99免除医院清单') > -1 ? 'readed_' : 'unread']">《除外医院清单》</a>
      <a href="javascript:;" @click="goFileView(12)"
        :class="[readArray.indexOf(12) > -1 ? 'readed_' : 'unread']">《特别约定和免责条款》</a>
      ，了解本产品的特点和保障内容。投保人声明填写的投保信息均真实有效
    </span>
    <span v-else>
      <a href="javascript:;" v-for="(item,index) in materialDtoList" :key="index" @click="goFileView(item.materialType, item.materialName)" :class="[readArray.indexOf(`${item.materialType}${item.materialName}`) > -1 ? 'readed_' : 'unread']">
      《{{item.materialName}}》
      </a>
      <span>，了解本产品的特点和保障内容。投保人声明填写的投保信息均真实有效</span>
    </span>
    <a-modal :width="1000" height="400px" class="pdfstyle myClause_cps" id="myClause_cps" forceRender title="预览"
      v-model="fileViewShow" @cancel="closeBtn">
      <div id="pdf">
        <div v-if="file1 == 2">
          <div id="pafdemo1_cps" v-html="url">
          </div>
        </div>
        <div v-if="file1 == 0">
          <div id="pafdemo1_cps"></div>
        </div>
      </div>
      <template slot="footer">
        <a-button class="mrg_r22_" @click="pushToRead" :disabled="readDisabled" type="primary">{{
          readDisabled
            ? "请下滑看完本内容再同意"
            : "我已阅读"
        }}</a-button>
      </template>
    </a-modal>
    <span v-show='isAllReadShow'>{{isAllRead}}</span>
  </span>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》'
	import { mapState } from 'vuex';
  import Pdfh5 from "pdfh5";
  export default {
    //import引入的组件需要注入到对象中才能使用
    // components: { pdf },
    data() {
      //这里存放数据
      return {
        file1: 2,
        isAllReadShow: false,
        numPages: 1,
        itemIndex: '',//当前的文件下标
        url: "",
        fileViewShow: false,
        fileContent: null,
        readArray: [],
        readDisabled: true
      };
    },
    props: {
      insureContent: {
        type: String,
        default: ''
      }
    },
    //监听属性 类似于data概念
    computed: {
			...mapState({
				agreementData: (state) => state.insureDoc.agreementData,//产品文件数据
			}),
      // 必读文件
      materialDtoList() {
        return this.agreementData.materialDtoList.filter(item => {
          return item.whetherMandatoryRead === '1';
        });
      },
      isAllRead() {
        //判断是否全部阅读
        const productReadNum = {
          '5IE2250002': 4,
          'GFTYX20H': 6,
          'GFTYX2023': 6
        }
        const num = productReadNum[this.$route.query.p]
        if (
            (!num && this.readArray.length == 3) || 
            (num && this.readArray.length == num)
          ) {
          //三次阅读
          this.$store.commit('setagreementAllRead', true);
        } else {
          this.$store.commit('setagreementAllRead', false);
        }
        return true;
      }
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      //文件阅读
      goFileView(num, name) {
       this.itemIndex = num;
        if(name) {
          this.itemIndex = num + name;
        }
        let materialDtoList = this.agreementData.materialDtoList;
        let file = materialDtoList.filter(item => {
          if(name) {
            return item.materialType == num && item.materialName.indexOf(name) > -1
          }
          return item.materialType == num
        });
        if (file && file.length) {
          this.fileViewShow = true;
          this.fileContent = file[0];
          this.readDisabled = true
          this.file1 = this.fileContent.materialForm;
          document.getElementById('pafdemo1_cps').innerHTML = ''
          var pdfH5;
          this.$nextTick(() => { //重制滚动状态
            if (this.file1 == 0) {
              if (this.$route.query.planCode == "GFTYX20Htwo" && num === 12) {
                // 免责条款
                pdfH5 = new Pdfh5('#pafdemo1_cps', {
                  pdfurl: 'https://image.ssish.com/core/material/1672821893276.pdf'
                })
              } else if(this.$route.query.planCode == "GFTYX20Hone" && num === 12) {
                // 免责条款
                pdfH5 = new Pdfh5('#pafdemo1_cps', {
                  pdfurl: 'https://image.ssish.com/core/material/1672821844409.pdf'
                })
              } else if(name === '拒保职业清单') {
                // 拒保职业清单
                pdfH5 = new Pdfh5('#pafdemo1_cps', {
                  pdfurl: '/files/guofu/3.3国富人寿拒保职业清单JB202212.pdf'
                })
              }  else if(name === '免除医院清单') {
                // 免除医院清单
                pdfH5 = new Pdfh5('#pafdemo1_cps', {
                  pdfurl: '/files/guofu/国富人寿意外伤害医疗保险责任和意外伤害住院津贴保险责任免除医院清单2023版.pdf'
                })
              } else {
                pdfH5 = new Pdfh5('#pafdemo1_cps', {
                  pdfurl: this.fileContent.materialContent
                })
              }
            } else {
              if (this.$route.query.p == "GFTYX20H" && num === 5) {
                this.url = this.insureContent
              } else {
                this.url = this.fileContent.materialContent
              }
            }
            this.$nextTick(() => {
              let pdf = document.getElementById('myClause_cps').querySelector(".ant-modal-body")
              if(this.file1 == 0){
                pdfH5.on("complete", (status)=> {
                  if(status == 'success' || status == 'error'){
                      pdf.addEventListener('scroll', this.bodyScroll);
                  }
                })
              }else{
                pdf.addEventListener('scroll', this.bodyScroll);
              }
            })
          })
        } else {
          if (this.readArray.indexOf(this.itemIndex) == -1) {
            this.readArray.push(this.itemIndex)
          }
          this.$message.warning("本产品未配置该文件!");
        }
      },
      async bodyScroll() {
        let pdf = document.getElementById('myClause_cps').querySelector(".ant-modal-body")
        let padview = document.getElementById('pafdemo1_cps').querySelector(".pdfViewer") || document.getElementById('pafdemo1_cps')
        let scrollTop = pdf.scrollTop //滚动距离
        let modalHeight = pdf.clientHeight; // 弹窗高度
        let clientHeight = padview.clientHeight//大小
        if ((clientHeight > 0 && scrollTop > 0) && (scrollTop + 1200 >= clientHeight)) { //滚动距离 + 窗口大小 == 容器大小 即触底
          this.readDisabled = false
        }
        if (clientHeight < modalHeight - 48 && clientHeight != 0) {
          this.readDisabled = false
        }
      },
      pushToRead() {
        this.fileViewShow = false
        if (this.readArray.indexOf(this.itemIndex) == -1) {
          this.readArray.push(this.itemIndex)
        }
      },
      closeBtn() {
        this.url = ""
        this.fileViewShow = false
      },
    },
  };
</script>
<style scoped>
  .pdfstyle>>>.ant-modal-body {
    height: 70vh;
    overflow-y: auto;
  }

  .myClause_cps .ant-modal-footer {
    text-align: center !important;
  }

  .unread {
    color: red;
  }

  .viewerContainer {
    overflow: visible !important;
  }
</style>